export default {
    // Sidebar
    'Nova OS Proativa': "Nueva OT proactiva ",
    'Interno': "Interno",
    'Externo': "Externo",
    'Preventiva': "Preventiva",
    'Preventiva Programada':  "Preventiva Programada",
    "Preventiva Programada Armazém": "Preventiva Programada Almacén",
    'Reaberta': "Reabierto",
    'Execuções': "Ejecuciones",
    'Armazém': "DEPOSITO",
    'Frota': "Flota",
    'Sair': "Salir",
    'Inventário':  "Inventário",

    // Nova Os
    'Voltar': "Volver",
    'Nova OS': "Nueva OT",
    'Operação': "Operación",
    'Placa': "Placa",
    'Segmento': "Segmento",
    'Problemas': "Problemas",
    'Descrição do Problema': "Descripción del problema",
    'Gerar OS': "Generar OT",
    'Cancelar': "Cancelar",

    // OS Interna
    "Nenhum resultado encontrado": "Ningún resultado encontrado",
    "Exibindo resultado": "Mostrando resultado",
    "de": "en",
    "Aberta há": "Abierta hace",
    "Concluída em": "Concluída en",
    "Falha ao carregar os dados da OS": "Error al cargar los datos de la OT",
    "Falha ao carregar os itens da OS": "Error al cargar los elementos de la OT",

    // Ordem Servico
    "Detalhes": "Detalles",
    "Mostrar": "Mostrar",
    "Esconder": "Ocultar",
    "Telefone": "Teléfono",
    "Data": "Fecha",
    "Início": "Inicio",
    "Final": "Final",
    "Fornecedor": "Proveedor",
    "Tipo": "Tipo",
    "Ciclo preventiva": "Ciclo preventivo",
    "Criticidade": "Criticidad",
    "Previsão de Atendimento": "Previsión de Atención",
    "Atendimento do Item": "Atención del Ítem",
    "Observações": "Observaciones",
    "Imagens": "Imágenes",
    "Salvar": "Guardar",
    "Ordens de Serviço": "Órdenes de trabajo",
    "GERADA_CHECKLIST": "GENERADA A PARTIR DEL CHECKLIST",
    "OBS_CHECKLIST": "OBSERVACIONES DEL CHECKLIST:",
    "OS_INTERNA": "OT INTERNA:",
    
    // OS Item
    "Iniciar": "Iniciar",
    "Ações": "Acciones",
    "Continuar": "Continuar",
    "Pausar": "Pausar",
    "Registrar Peças": "Registrar Piezas",
    "Cancelar OS": "Cancelar OT",
    "OS Externa": "OT Externa",
    "Insira um serviço. Tente novamente.": "Ingrese un servicio. Inténtalo de nuevo.",
    "Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado.": "Esta Orden de Trabajo ya ha sido cerrada en GINFO. El servicio ya no puede ser modificado.",
    "Somente Consulta": "Solo Consulta",
    "Ordem de Serviço Encerrada": "Orden de Trabajo Cerrada",
    "Ordem de Serviço Cancelada": "Orden de Trabajo Cancelada",

    // Modal Itens
    "Serviços": "Asistencia",
    "SERVIÇOS": "ASISTENCIA",
    "Observação": "Observación",
    "Anexo de arquivos": "Adjunto de archivos",
    "Oops!": "¡Ups!",
    "Tipo de arquivo não permitido.": "Tipo de archivo no permitido.",
    "Vídeo muito grande": "Vídeo demasiado grande",
    "O limite para anexos de vídeo é de 20MB. Grave um vídeo mais curto ou reduza a qualidade antes de anexar.": "El límite para adjuntos de vídeo es de 20MB. Grabe un vídeo más corto o reduzca la calidad antes de adjuntarlo.",
    "Informe o valor total dos serviços/peças": "Informe el valor total de los servicios/piezas",
    "Informe o motivo do socorro em rota": "Informe el motivo de la asistencia en ruta",
    "Informe o pneu utilizado neste serviço": "Informe el neumático utilizado en este servicio",
    "Foi trocado o pneu": "Se cambió el neumático",
    "Finalizar OS": "Finalizar OS",

    // Modal se foi utilizado peças
    "Foi utilizado Peças?": "¿Se utilizaron Piezas?",
    "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!": "Si se utilizaron piezas en esta atención, ¡presiona 'Sí' en la opción de abajo!",
    "Não": "No",
    "Sim": "Sí",

    // Modal Itens Fim
    "Informe os itens utilizados neste serviço": "Informe los elementos utilizados en este servicio",
    "Fechar": "Cerrar",
    "Peças": "Piezas",
    "Peça": "Pieza",
    "Quantidade": "Cantidad",
    "Qtde": "Stock",
    "Localização": "Ubicación",
    "Não informado": "No informado",
    "Preço": "Precio",
    "Informe o pneu novo": "Informe el neumático nuevo",

    // Modal Pause
    "Informe a Justificativa": "Informe la Justificativa",
    "Confirmar Pausa": "Confirmar Pausa",
    "Justificativa": 'Justificativa',
    "ir ao banheiro": 'ir al baño',
    "Fim de expediente": 'Fin del negocio',
    "Atendimento": 'Servicio',
    "Refeição": 'Almuerzo',
    "Aguardando Peças": 'Esperando piezas',
    "Auxílio externo": 'Asistencia externa',
    'Selecione qual peça está aguardando': 'Seleccione qué repuesto está esperando',

    // Confirmar OS Externa
    "Confirmar OS Externa": "Confirmar Orden de Servicio Externa",
    "Deseja realmente enviar OS": "¿REALMENTE QUIERES ENVIAR LA OT",
    "Confirmar": "Confirmar",

    // Lista de execução
    "Lista de execução": "Lista de ejecución",
    "Nenhuma execução ativa": "Ninguna ejecución activa",
    "Início Atendimento": "Inicio Atención",
    "Encerrar OS": "Cerrar OT",
    "Acessar OS": "Acceder OS",
    "Colaborador": "Colaborador",
    "Execuções em Pause": "Ejecuciones en Pausa",
    "Nenhuma execução em pause": "Ninguna ejecución en pausa",

    // Login
    "Torne sua rotina mais dinâmica": "Haz tu rutina más dinámica",
    "ACESSO AO SISTEMA": "ACCESO AL SISTEMA",
    "Terminal Oficina": "Terminal del Taller",
    "Realize o login e tenha acesso ao controle": "Inicia sesión y accede al control",
    "e gestão de suas Ordens de Serviço": "y gestión de tus Órdenes de Trabajo",
    "Mecânico Externo": "Mecánico Externo",
    "Acessar": "Acceder",
    "Falha ao fazer login": "Fallo al iniciar sesión",

    // Filtros Internas
    "Ordenar": "Ordenar",
    "Antigas Primeiro": "Antiguas Primero",
    "Recentes Primeiro": "Recientes Primero",
    "Maior": "Mayor",
    "Menor": "Menor",
    "Segmentos": "Segmentos",
    "Período": "Período",
    "Execução": "Ejecución",
    "Todos": "Todos",
    "Pendentes": "Pendientes",
    "Pendente": "Pendiente",
    "Finalizadas": "Finalizadas",
    "Aplicar filtro": "Aplicar filtro",
    "Limpar filtros": "Limpiar filtros",
    "Esconder filtros": "Ocultar filtros",
    "Criado por": "Creado por",
    "Usuário": "Usuario",
    "Ação": "Acción",

    // Os Preventivas
    "Filtre as OS Preventivas": "Filtre las OT Preventivas",
    "Preventivas Vencidas": "Preventivos Vencidos",
    "Preventivas à Vencer": "Preventivos que están por vencer",
    "Carrocerias Vencidas": "Preventivos de caja vencidos",
    "Atualizar": "Actualizar",

    // Modais Preventivas
    "ACAO": "ACCIÓN",
    "PLACA": "PLACA",
    "PROXIMO_CICLO": "PRÓXIMO CICLO",
    "VENCIMENTO": "VENCIMIENTO",
    "PROXIMO_KM": "PRÓXIMO KM",
    "KM_ATUAL": "KM ACTUAL",
    "Vincular Fornecedor": "Vincular Proveedor",

    // Inventário
    "Não contados": "Sin contar",
    "Contados": "Contados",
    "Ordenação": "Ordenación",
    "Total Itens": "Articulos totales",
    "Status": "Estado",
    "Inventário criado com sucesso!": "¡Inventario creado con éxito!",
    "Já existe um inventário em execução": "Ya existe un inventario en ejecución",
    "Deseja iniciar um novo inventário?": "¿Desea iniciar un nuevo inventario?",
    "Inventário de Estoque": "Inventario de Stock",

    // Modal atendimento

    "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade": "CONFIRME SU IDENTIDAD CON SUS 3 PRIMEROS NUMEROS DE SU REGISTRO",
    'Confirmar identidade': "Confirmar Identidad",

    "Erro do Motorista": "Error del controlador",
    "Defeito não Encontrado": "Defecto no encontrado",

    "Informe o serviço": "Informar al servicio",
    "Insira os Itens": "INSERTAR LOS ELEMENTOS: REGISTRAR LAS PIEZAS",

    "Alterar Fornecedor": "Cambiar proveedor",
    "Preventivas Armazém": "Preventivos Deposito",
    "Outros": "Otros",
    "Ver Encerradas": "VISUALIZAR LISTA DE LAS ULTIMAS OT CERRADAS",
    "Tem dúvida?": "Tienes Dudas?",
    "Nenhuma OS aguardando aprovação": "No hay ningún sistema operativo pendiente de aprobación",
    "Aguardando Aprovação": "en espera de aprobación",


    "OS Preventivas Vencidas": "OT Preventivos vencidos",

    "OS Encerradas - Últimas 15 OS": "OT CERRADAS- ULTIMAS 15 OT",
    "DATA": "FECHA",

    'Precisa de Ajuda?': '¿Necesitas Ayuda?',
    'Desejamos um ótimo 2024!': 'Desejamos un próspero 2024',

    'Bem vindo(a) ao Terminal da Borracharia!': 'Bienvenidos a la Gomeria!',
    'Realize a gestão de pneus pelo novo terminal da borracharia!': '¡Administre neumáticos usando la nueva terminal de tienda de neumáticos!',
    'Aderência Aferição 01': 'ADHERENCIA DE CALIBRACIÓN DE',
    'Aderência Aferição 02': 'ADHERENCIA DE MEDICIÓN DE',
    'de Calibragem': 'CALIBRACIÓN',
    'Aferição': 'Exploración',
    'Movimentação/Troca': 'Movimiento/Intercambio',
    'Descarte': 'Desecho',
    'Serviço': 'Servicio',
    'Borracharia': 'Tienda de Neumáticos',
    'Placas': 'Patente / Placa',
    'Inverter pneus': 'Invertir neumáticos',

    'AÇÃO': 'ACCIÓN',
    'TIPO': 'TIPO',
    'CONJUNTO': 'COLOCAR',
    'AFERIÇÃO': 'MEDICIÓN',

    'Selecione um Pneu': 'Seleccione un neumático',
    'Informar KM': 'Reportar kilómetros',
    'Informar Aferição': 'Informe de Medición',
    'Aferindo NR Informar Calibragem': 'Medición NR Fuego',
    'Última Aferição': 'Última Medición',
    'Novas Aferições': 'Nuevas Medición',
    'Última aferição NR fogo': 'Última medición nº fuego',
    'Registrar Aferições': 'Registrar Medidas',
    'Realizar avaliação': 'Realizar evaluación',
    'Preditiva': 'Predictivas',
    'Externas Armazém': 'Deposito Externo',
    'Carrocerias à Vencer': 'Preventivos de la Caja',

    'Problema': 'Problema',
    'Descartes': 'Descartes',

    'OS Preditiva': 'OT PREDICTIVA',

    "Fora do Prazo": "Fuera de plazo",
    "Dentro do Prazo": "Dentro del plazo",
    
    'Gerar OS Preditiva': 'GENERAR OT PREDICTIVA',
    'Iniciar novo inventário': 'Iniciar un nuevo inventario',
    'Dt Inicial': 'Fecha inicial',
    'Dt Final': 'Fecha final',
    
    "CALIBRAGEM": "CALIBRACIÓN",
    "Nunca feito": "Nunca Realizado",
    "FOGO": "FUEGO",
    "Informar Calibragem": "Informe de Calibración",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Comience a escribir el nombre del proveedor que desea mostrar en la lista a continuación.",

    "Portugues": "Portugués",
    "Mercosul": "Mercosur",
    "Ingles": "Inglés",
    'Frances': "Francés",
    'Alemao': 'Alemán',
    'Holandes': 'Holandés',
    'Espanhol': 'Español',
    
    "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "EL ESFUERZO DE HOY ES EL ÉXITO DE MAÑANA",

    "CODIGO OS": "CÓDIGO OT",
    "TODOS": "TODOS",
    "Socorro em Rota pendente de atendimento": "Asistencia en ruta pendiente de atención",
    "FILTROS": "FILTROS",
    "Salvar Filtro": "Guardar filtro",
    "Motorista": "Conductor",
    "Orçamento": "Presupuesto",
    "Confirmar Orçamento": "Confirmar presupuesto",
    "Deseja pausar esta OS para aguardar o orçamento?": "¿Desea pausar esta orden de trabajo para esperar el presupuesto?",
    "Valor": "Valor",
    "Pausar OS": "Pausar OT",
    "Comentarios": "Comentarios",
    "Insira um comentário": "Ingrese un comentario",
    "Enviar OS": "Enviar OT",
    "Selecione uma justificativa": "Seleccione una justificación",
    "Anexos": "Adjuntos",
    "OS Socorro em Rotas": "Asistencia en ruta",
    "Confirmar Cancelamento": "Confirmar cancelación",
    "Buscar Placa": "Buscar placa",
    "Pesquisa de OS por placa": "Búsqueda de OT por placa",
    "CONTRATO_CONCESSIONARIA": "CONTRATO DE CONCESIONARIA",

    "Ordem gerada com sucesso": "Orden generada con éxito",
    "Sucesso": "Éxito",
    "Selecionar Todos": "Seleccionar todos",
    "Descrição": "Descripción",
    "Registrar Serviços": "Registrar servicios",
    "Visualizar Itens": "Ver ítems",
    "Clique no botão a direita para registrar as peças": "Haga clic en el botón de la derecha para registrar las piezas",

    "Selecionar técnico": "Seleccionar técnico",
    "KM atual/Horimetro": "Kilometraje actual/Horómetro",
    "Deseja inserir alguma imagem no atendimento": "¿Desea agregar alguna imagen al servicio?",
    "Para concluir a ação, selecione abaixo o técnico responsável": "Para completar la acción, seleccione a continuación el técnico responsable.",
    "Trabalhando": "Trabajando",
    "Matricula": "Matrícula",
    "Serviços registrado com sucesso": "Servicios registrados con éxito",
    "Função": "Función",
    "Enviar Anexos": "Enviar adjuntos",
    "Gerar Preventiva Programada": "Generar preventiva programada",
    "OS Preventiva Programada": "OT preventiva programada",
    "Finalize todas as peças e serviços para encerrar o atendimento": "Finalice todas las piezas y tareas para cerrar el atendimiento",
    "Insira um KM maior que o anterior": "Ingrese un kilometraje mayor que el anterior",
    "Insira um KM maior que o atual": "Ingrese un kilometraje mayor que el actual",
    "Inserir anexos": "Insertar adjuntos",
    "Planos Preventivos": "Planes preventivos",
    "Filtro": "Filtro",
    "ULTIMA": "ÚLTIMA",
    "Gerar Preditiva": "Generar predictiva",
    "Carregando": "Cargando",
    "OS Preventiva Programada Armazém": "OT preventiva programada almacén",
    "Gerar OS Preventiva Programada": "Generar OT preventiva programada",
    "OS Preventivas à Vencer": "OT preventivas por vencer",
    "OS de Transição": "SO de transición",

    "IMEDIATA": "INMEDIATA",
    "EMERGENCIAL": "EMERGENCIA",
    "ALTA": "ALTA",
    "MÉDIA": "MEDIA",
    "LEVE": "BAJA",

    "Registrar Tarefas": "Registrar Tareas",
    "Desbloqueia Empilhadeira": "Desbloquear Autoelevador",
    "OS Ag. Aprovação": "OT Ag. Aprobación",
    "OS Internas Veículos": "OT Internas Vehículos",
    "OS Internas Armazém": "OT Internas Depósito",
    "OS Reabertas": "OT Reabiertas",
    "Criticidade de OS Abertas": "Criticidad de las OT Abiertas",
    "Top 20 Placas com mais OS": "Top 20 Placas con más OT",
    "Qtd OS": "Cantidad OT",

    // Dashboard
    "Criticidade de OS abertas": "Criticidad de OT abiertas",
    "URGENTE": "URGENTE",
    "PREVENTIVA": "PREVENTIVA",
    "CRITICIDADES": "CRITICIDADES",
    "Bem Vindo(a)": "Bienvenido(a)",
    "Tenha acesso as principais": "Tenga acceso a las principales",
    "informações da sua mecânica!": "informaciones de su taller!",
    "Ver OS internas": "Ver OT internas",
    "OS TicketLog": "OT TicketLog",
    "OS Externas": "OT Externas",
    "OS Interna Veículos": "OT Interna Vehículos",
    "OS Interna Armazém": "OT Interna Depósito",
    "Ranking dos Mecânicos": "Ranking de los Mecánicos",
    "Tipo de OS": "Tipo de OT",
    "Atendidas nos últimos 30 dias": "Atendidas en los últimos 30 días",
    "TOP 20 Placas com mais OS": "TOP 20 Placas con más OT",
    "Últimos 30 dias": "Últimos 30 días",
    "Placas com OS Externas": "Placas con OT Externas",
    "TOP 10 Problemas mais atendidos": "TOP 10 Problemas más atendidos",
    "Nos últimos 30 dias": "En los últimos 30 días",
    "Status por Mecânico": "Estado por Mecánico",
    "Produtividade": "Productividad",

    // ModalEncerradas
    "Filtros": "Filtros",
    "NÚMERO": "NÚMERO",
    "INÍCIO": "INICIO",
    "FINAL": "FINAL",
    "SEGMENTO": "SEGMENTO",
    "PROBLEMA": "PROBLEMA",
    
    // Login
    "Acesso Rápido": "Acceso rápido",
    "ID": "ID",
    "CNPJ": "ID",
    "codigo_fornec": "code",
    "Para qual fornecedor você deseja enviar esta OS": "A qué proveedor le gustaría enviar este pedido",
    'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': 'Si se utilizaron piezas en este servicio, pulse "Sí" en la opción que aparece a continuación.',
    "FILTRO EMPRESA": "FILTRO DE LA EMPRESA",
    "Upload Arquivos": "Subir archivos",
    "Cards": "Tarjetas",
    "Colunas": "Columnas",
    "ULTIMA MM": "ÚLTIMA MM",
    "PRÓXIMA MM": "PRÓXIMA MM",
    "ULTIMA CAL": "ÚLTIMA CAL",
    "PRÓXIMA CAL": "PRÓXIMA CAL",

    "ULTIMA MOVIMENTACAO": "ÚLTIMA MOVIMENTACIÓN",
    "PRÓXIMA MOVIMENTACAO": "PRÓXIMA MOVIMENTACIÓN",
    "N° FOGO": "N° FUEGO",
    "FILIAL": "SUCURSAL",
    "MARCA": "MARCA",
    "MEDIDA": "MEDIDA",
    "MODELO": "MODELO",
    "POSIÇÃO": "POSICIÓN",

    "Aguardando Aprovação de Sinistro": "Pendiente de aprobación del siniestro",
    "Aguardando Liberacao": "Pendiente de liberación",
    "Nenhuma OS aguardando liberacao": "Ninguna orden de servicio pendiente de liberación",
    
    "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão": 
    "El tiempo total es inferior a 5 minutos. Esto podría afectar negativamente el control de gestión",
    "Aguardar Liberação": "Esperando Liberación",

    "CONTRATO CONCESSIONARIA": "CONTRATO DE CONCESIONARIO",

    // Chaves adicionadas para i18n completo
    "Adicionar Serviços": "Agregar Servicios",
    "Aferindo NR Fogo": "Midiendo NR Fuego",
    "CD_PNEU": "COD_NEUMATICO",
    "CPF (3 primeiros digitos)": "CPF (3 primeros dígitos)",
    "Cadastro": "Registro",
    "Calibragem NR Fogo": "Calibración NR Fuego",
    "Confirmar envio Ticket": "Confirmar envío Ticket",
    "Conserto de Pneus": "Reparación de Neumáticos",
    "DS_PREDITIVO": "DESCRIPCIÓN PREDICTIVA",
    "DashBoard": "Dashboard",
    "Dashboard": "Dashboard",
    "Data Final": "Fecha Final",
    "Data Inicial": "Fecha Inicial",
    "Data OS": "Fecha OT",
    "Descartar": "Descartar",
    "Descarte Pneus": "Descarte de Neumáticos",
    "Deseja enviar para TicketLog a OS": "¿Desea enviar la OT a TicketLog?",
    "Digite para pesquisar": "Escriba para buscar",
    "Enviar": "Enviar",
    "Equipamento Liberado": "Equipo Liberado",
    "Escreva seu script aqui": "Escriba su script aquí",
    "Informar Sinistro": "Informar Siniestro",
    "Informe o KM do Pneu": "Informe el KM del neumático",
    "Informe o serviço feito!": "¡Informe el servicio realizado!",
    "Insira o KM do veículo:": "Ingrese el KM del vehículo:",
    "Insira os Serviços": "Ingrese los Servicios",
    "Inventário de estoque": "Inventario de stock",
    "Início Atendimento OS": "Inicio Atención OT",
    "Item": "Ítem",
    "Itens:": "Ítems:",
    "KM": "KM",
    "KM PROX.": "KM PRÓX.",
    "Lançamento de item": "Registro de ítem",
    "Lista": "Lista",
    "Matrícula": "Matrícula",
    "Motivo": "Motivo",
    "NR Fogo": "NR Fuego",
    "OS Preventiva Vencida": "OT Preventiva Vencida",
    "Observacao": "Observación",
    "PROX. CICLO": "PRÓX. CICLO",
    "Para qual fornecedor você deseja enviar esta OS?": "¿A qué proveedor desea enviar esta OT?",
    "Pesquisa global": "Búsqueda global",
    "Pesquisar": "Buscar",
    "Pesquisar Item": "Buscar ítem",
    "Pesquisar peça": "Buscar pieza",
    "Pesquisar serviço": "Buscar servicio",
    "Planos": "Planes",
    "Pneus a Placa:": "Neumáticos de la placa:",
    "Próximo Ciclo": "Próximo Ciclo",
    "Pular": "Saltar",
    "Selecione a empresa": "Seleccione la empresa",
    "Selecione um fornecedor": "Seleccione un proveedor",
    "Selecione um motivo": "Seleccione un motivo",
    "Servicos": "Servicios",
    "Sinalizar Sinistro": "Señalar Siniestro",
    "Sucesso!": "¡Éxito!",
    "Vencimento": "Vencimiento",

    // Chaves complementares
    "Ir ao banheiro": "Ir al baño",

    // Mensagens de validação
    "Preenchimento obrigatório": "Campo obligatorio",
    "Disponível": "Disponible",
    "Deve ser maior que 0": "Debe ser mayor que 0",
    "Não pode ser negativo": "No puede ser negativo",
    "Valor Unitário": "Valor Unitario",
    "Existem filtros salvos e aplicados": "Hay filtros guardados y aplicados",
    "Adicionar Arquivos": "Agregar archivos",
    "Ordem de Serviço criada com Sucesso": "Orden de servicio creada con éxito",
    "Falha ao parar execução. Tente novamente": "Error al detener la ejecución. Inténtelo de nuevo.",
"Selecionar": "Seleccionar",
"Insira todas as informações": "Introduzca toda la información",
"Item registrado com sucesso": "Elemento registrado con éxito",
"Insira um preço": "Introduzca un precio",
"OS Preventiva A Vencer": "Órdenes de trabajo preventivas próximas a vencer",
"OS já está aberta": "La orden de trabajo ya está abierta",
"Não trabalhando": "No trabajando",

"ABASTECIMENTO": "REABASTECIMIENTO",
"CHECKLIST": "LISTA DE VERIFICACIÓN",
"CHECKLIST CONFORMIDADE": "LISTA DE VERIFICACIÓN DE CONFORMIDAD",
"PREVENTIVA CARROCERIA": "MANTENIMIENTO PREVENTIVO DE CARROCERÍA",
"SOCORRO EM ROTA": "ASISTENCIA EN RUTA",
"finalizado": "Finalizado",
"contagem": "Conteo",
"contagem_de_itens": "Conteo de Ítems",
"codigo": "Código",
"saldo_atual": "Saldo Actual",
"item_nao_registrado_tente_novamente": "Elemento no registrado, inténtelo de nuevo",
"versao": "Versión",
"informe_a_leitura_de_todos_os_sulcos": "Ingrese la lectura de todos los surcos",
"Faça a leitura de todos os pneus para registrar": "Realice la lectura de todos los neumáticos para registrarlos",
"Leitura registrada com sucesso": "Lectura registrada con éxito",


    // Anexos do descarte de pneus
    "Anexar documento": "Adjuntar documento",
    "Selecione o tipo do documento e o arquivo para anexar ao descarte": "Seleccione el tipo de documento y el archivo para adjuntar al descarte",
    "Tipo de documento": "Tipo de documento",
    "Selecione um anexo": "Seleccione un adjunto",
    "Adicionar documento": "Agregar documento",
    "Extensão não permitida": "Extensión no permitida",
    "Arquivo excede o tamanho máximo de": "El archivo excede el tamaño máximo de",
    "Informe o tipo do documento": "Informe el tipo de documento",
    "Descarte realizado, mas falhou o envio dos anexos": "Descarte realizado, pero falló el envío de los adjuntos",
    "Descarte realizado com sucesso!": "¡Descarte realizado con éxito!",
    "Erro ao descartar pneu, tente novamente!": "¡Error al descartar el neumático, inténtelo de nuevo!",
    "Informe o KM atual!": "¡Informe el KM actual!",

    "Selecione um Fornecedor": "Seleccione un Proveedor",
    "Preencha todas as informações": "Complete toda la información",
    "Origem": "Origen",
    "Interna": "Interna",
    "Externa": "Externa",

  "CORRETIVA": "CORRECTIVA",
  "REFORMA": "REACONDICIONAMIENTO",
  "Informações sobre OS": "Información sobre la OT",
  "SERVIÇO": "SERVICIO",
  "PEÇA": "PIEZA",
  "Sem execução": "Sin ejecución",
  "Atenção!": "¡Atención!",
  "Situação": "Situación",
  "Carroceria": "Carrocería",
  "Cavalo": "Tractocamión",
  "24 HORAS": "24 HORAS",
  "48 HORAS": "48 HORAS",
  "72 HORAS": "72 HORAS",
  "4 HORAS (HORÁRIO COMERCIAL)": "4 HORAS (HORARIO COMERCIAL)",
  "Falha ao pausar execução. Tente novamente.": "Error al pausar la ejecución. Inténtelo de nuevo.",
  "Falha ao cancelar execução. Tente novamente.": "Error al cancelar la ejecución. Inténtelo de nuevo.",
  "Informe uma justificativa": "Indique una justificación",
  "Informe uma nota": "Indique una calificación",
  "Informe uma peça": "Indique una pieza",
  "Informe o KM atual": "Indique el KM actual",
  "Informe uma aferição menor que a atual!": "¡Indique una medición menor que la actual!",
  "Insira todas as informações!": "¡Introduzca toda la información!",
  "Insira um anexo para registrar o sinistro!": "¡Adjunte un archivo para registrar el siniestro!",
  "Ordem gerada com sucesso!": "¡Orden generada con éxito!",
  "Selecione um fornecedor!": "¡Seleccione un proveedor!",
  "Selecione todos os serviços!": "¡Seleccione todos los servicios!",
  "Selecione um motivo!": "¡Seleccione un motivo!",
  "Selecione um serviço!": "¡Seleccione un servicio!",
  "Serviço realizado com sucesso!": "¡Servicio realizado con éxito!",
  "Erro ao enviar pneu para serviço, tente novamente!": "¡Error al enviar el neumático a servicio, inténtelo de nuevo!",
  "Qual é o tipo de OS?": "¿Cuál es el tipo de OT?",
  "Você deseja direcionar esta OS como externa ou como interna?": "¿Desea dirigir esta OT como externa o como interna?",
  "Pneu vinculado com sucesso!": "¡Neumático vinculado con éxito!",
  "Esta Ordem de Serviço está cancelada no GINFO. O atendimento não pode mais ser alterado.": "Esta orden de trabajo está cancelada en GINFO. La atención ya no puede modificarse.",
  "Existem posições sem pneu aplicado!": "¡Hay posiciones sin neumático aplicado!",
  "Entre no menu Movimentações e aplique os pneus deste caminhão.": "Entre en el menú Movimientos y aplique los neumáticos de este camión.",
  "Layout": "Diseño",
  "Meus Atendimentos": "Mis atenciones",
  "Seu usuário não tem permissão para criar OS Proativa!": "¡Su usuario no tiene permiso para crear OT proactiva!",
  "SLA": "SLA",
  "Ciclo": "Ciclo",
  "Mecânico": "Mecánico",
  "Suas Avaliações": "Sus evaluaciones",
  "Avaliação referente as OS atendidas nos últimos 30 dias.": "Evaluación de las OT atendidas en los últimos 30 días.",
  "Nota": "Calificación",
  "Nota selecionada": "Calificación seleccionada",
  "Opcional": "Opcional",
  "Horas Trabalhadas": "Horas trabajadas",
  "Qtd": "Cant",
  "Página em manutenção": "Página en mantenimiento",
  "A página de OS de empilhadeira está em desenvolvimento": "La página de OT de montacargas está en desarrollo",
  "A página de OS de transpaleteira está em desenvolvimento": "La página de OT de transpaleta está en desarrollo",
}
